import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { initialState as defaultState } from '../../../slices/joinOtaIndividual';
import { fetchFormInitialData } from '../../../services/joinOtaIndividual/fetchFormInitialData';
import { IPublicV1ReceiptDetailsGetResponseSchema } from '../../../repositories/dailyrent/entities/response/PublicV1ReceiptDetailsGetResponseSchema';

export const fetchInitialFormData = createAsyncThunk<IPublicV1ReceiptDetailsGetResponseSchema, void, IThunkApi>(
  'joinOtaIndividual/fetchInitialFormData',
  async (_params, thunkApi) => {
    const { extra: context } = thunkApi;

    try {
      const { statusCode, response } = await fetchFormInitialData(context);

      if (statusCode === 200) {
        return response;
      }

      return defaultState;
    } catch (e) {
      return defaultState;
    }
  },
);
